import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { COE_UPDATES } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={COE_UPDATES} id={id} />;
}

export const Route = createFileRoute("/_app/coe/updates/$id")({
  component: Edit,
});
